/** Normalise any thrown value into a plain, log-safe object. */
export function serializeError(err: unknown): Record<string, unknown> {
  if (err instanceof Error) return { name: err.name, message: err.message, stack: err.stack };
  if (typeof err === "object" && err !== null) return err as Record<string, unknown>;
  return { value: String(err) };
}
